import { createContext } from "react"
import { UserContext as UserContextType } from "./types"
import { initial_user } from "./reducer"

const UserContext = createContext<UserContextType>({ user: initial_user, dispatch: () => null })
export default UserContext
